import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LeftMenu from "@/layouts/LeftMenu.vue";
import UserManualData from "@/data/popup/UserManualData";
import PageHeader from "@/lib/components/layout/page/PageHeader.vue";
import UserManual from "@/lib/components/popup/UserManual.vue";
import BaseLayout from "@/lib/components/layout/BaseLayout.vue";


export default /*#__PURE__*/_defineComponent({
  name: 'AppLayout',
  setup(__props) {


const getUserManualElements = function() {
  return UserManualData.messages;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseLayout, null, {
    "left-menu": _withCtx(() => [
      _createVNode(LeftMenu, null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "left-menu")
        ]),
        _: 3
      })
    ]),
    "page-header": _withCtx(() => [
      _createVNode(PageHeader)
    ]),
    page: _withCtx(() => [
      _renderSlot(_ctx.$slots, "page")
    ]),
    "page-footer": _withCtx(() => [
      _renderSlot(_ctx.$slots, "page-footer")
    ]),
    "user-manual": _withCtx(() => [
      _createVNode(UserManual, {
        "user-manual-elements": getUserManualElements()
      }, null, 8, ["user-manual-elements"])
    ]),
    _: 3
  }))
}
}

})